import { Modal as _Modal } from "reactstrap";
export var Modal = _Modal;